export default "__VITE_ASSET__xvNTV1HZ__"